<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="organizationTypes"
    item-value="id"
    item-text="name"
    clearable
    return-object
  >
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "OrganizationTypeField",
  props: {
    value: Object,
    status: { type: String, required: false },
    allowAdjustments: { type: Boolean, default: null }
  },
  data: () => ({
    organizationTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    const payload = {
      isEffective: this.status
    };

    if (this.allowAdjustments !== null) {
      payload.allowAdjustments = this.allowAdjustments;
    }
    ApiService.post("/api/organizationTypes/search?size=100", payload).then(({ data }) => {
      this.organizationTypes = data.content;

      // Auto-select if only one option and nothing selected yet
      if (this.organizationTypes && this.organizationTypes.length === 1 && !this.value) {
        this.$emit("input", this.organizationTypes[0]);
      }
    });
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.$emit("change");
      }
    }
  }
};
</script>
